import { useEffect, useState } from 'react';
import api from '../../config/api';
import useStore from '../../config/store';

// Se recuerda por organización unos minutos: la lista y el detalle de
// vacantes lo piden al montarse
const CACHE_MS = 5 * 60 * 1000;
const cache = new Map(); // organizationId → { slug, at }

/**
 * Slug público de la organización ({slug}.amandahr.ai) para armar el link de
 * una vacante desde el ATS con getPositionUrl (/vacante/:id, 2026-10-25). Lo
 * puede leer cualquier usuario del ATS. Mientras carga, si la organización no
 * tiene slug o si falla la consulta devuelve null y el link va a
 * app.amandahr.ai, que funciona igual (la página se busca por el id de la
 * vacante, no por el subdominio).
 */
const useOrgPublicSlug = () => {
  const { organization, authToken } = useStore.getState();
  const [slug, setSlug] = useState(() => cache.get(organization)?.slug || null);

  useEffect(() => {
    if (!organization) return undefined;
    const hit = cache.get(organization);
    if (hit && Date.now() - hit.at < CACHE_MS) {
      setSlug(hit.slug);
      return undefined;
    }
    let alive = true;
    api
      .get('/organizations/ats-public-slug', {
        params: { organizationId: organization },
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((res) => {
        if (res.data?.response?.status_response !== 'OK') return;
        const value = res.data.response.data?.slug || null;
        cache.set(organization, { slug: value, at: Date.now() });
        if (alive) setSlug(value);
      })
      .catch((err) => console.error('Error loading the organization public slug:', err));
    return () => {
      alive = false;
    };
    // authToken se lee vía useStore.getState(); se deja fuera de deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organization]);

  return slug;
};

export default useOrgPublicSlug;
